import { Component, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { fuseAnimations } from '@fuse/animations';
import { CommonModule } from '@angular/common';
import { QRCodeModule } from 'angularx-qrcode';
import { ConfigService } from '../../../services/config.service';
import { FileService } from '../../../services/file.service';
import tinycolor from 'tinycolor2';
import { TranslocoPipe, TranslocoService } from '@ngneat/transloco';
import { DrakeSharedService } from '../../../services/drake-shared.service';
import { LanguagesComponent } from '../../../layout/common/languages/languages.component';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'environments/environment';
import { BrandingService } from 'app/services/branding.service';
import { StyleModel } from 'app/models/style';


@Component({
    selector: 'app-app-link',
    templateUrl: './app-link.component.html',
    styleUrls: ['./app-link.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        QRCodeModule,
        LanguagesComponent
    ],
    providers: [TranslocoPipe]
})
export class AppLinkComponent implements OnInit {
    style: StyleModel;
    emailConfirmedText: string = "..."


    constructor(private route: ActivatedRoute,
        private translocoService: TranslocoService,
        private brandingService:BrandingService) { }

    async ngOnInit(): Promise<void> {

        this.style = await this.brandingService.loadBranding('DEFAULT'); // Passa l'ID corretto

        const code = this.route.snapshot.queryParamMap.get('c');
        var appLink: string = ''
        if (code) {
            appLink = `${environment.appLink.protocol}://app?code=${code}`;
        } else {
            appLink = `${environment.appLink.protocol}://app`;
        }
        window.location.href = appLink;

        const androidStore = `https://play.google.com/store/apps/details?id=${environment.appLink.androidAppId}`;
        const iosStore = `https://apps.apple.com/app/id${environment.appLink.iosAppId}`;

        const userAgent = navigator.userAgent || navigator.vendor;
        
        setTimeout(() => {
            if (/android/i.test(userAgent)) {
                window.location.href = androidStore;
            } else if (/iPad|iPhone|iPod|Safari|Apple/.test(userAgent) && !(window as any).MSStream) {
                window.location.href = iosStore;
            }
        }, 3000);
    }

}
